module.exports = __webpack_public_path__ + "static/media/Kickboxer.dd394cad.jpg";